<template>
    <div  style="background-image: url('/gadmin.jpg')">
        <div class="uk-padding-large" style="background-color: rgba(0, 0, 0, 0.7)">
            <div class="uk-container" style="height: 300px">
                <div class="uk-child-width-1-2@m" uk-grid>
                    <div class=" uk-light">
                        <h2 style="font-weight: bolder">Graduate Admissions</h2>
                        <p style="font-size: large;  color: #c0c0c0;">
                            <span style="color: rgb(197, 179, 97);">
                                Graduate Studies applicants applying for admission to Northern Caribbean University
                            </span> <br>
                            Late applications may be considered but will attract late fees.
                        </p>
                    </div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "welcomeGAImage"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h2{
            font-size: 1.4em !important;
        }
        p{
            font-size: 0.8em !important;
        }
        .uk-padding-large{
            height: 200px !important;
        }

    }
</style>
